import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {Table} from 'react-bootstrap';

const TableSkeleton = ({rows = 5, columns = 4}) => {
  return (
    <Table hover responsive>
      <thead>
      <tr>
        {Array(columns).fill().map((_, index) => (
          <th key={index}>
            <Skeleton width={100}/>
          </th>
        ))}
      </tr>
      </thead>
      <tbody>
      {Array(rows).fill().map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array(columns).fill().map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton/>
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </Table>
  );
};

export default TableSkeleton;
